<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    @ok="pictureSure"
    @cancel="close"
    cancelText="关闭">

    <a-form-item label="多图片上传" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <el-upload
        list-type="picture"
        class="upload-demo"
        :show-file-list="true"
        :action="uploadAction"
        :data="{'isup':1}"
        :headers="headers"
        multiple
        drag
        :before-upload="beforeUpload"
        :on-change="handleChange"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </a-form-item>

    <a-form-item label="是否配置图片数据值" :labelCol="labelCol" :wrapperCol="wrapperCol"
                 v-show="isMultiple">
      <el-switch v-model="needDispose"></el-switch>
    </a-form-item>
    <a-row class="form-row" :gutter="24" v-for="(fData,index) in fileDatas" :key="index"
           v-show="needDispose==true">
      <a-col :md="12" :sm="8">
        <a-form-item label="文件名" :labelCol="{span: 10}" :wrapperCol="{span: 10}">
          <a-input v-model="fData.fileName"/>
        </a-form-item>
      </a-col>

      <a-col :md="12" :sm="8">
        <a-form-item label="数据值" :labelCol="{span: 5}" :wrapperCol="{span: 10}">
          <a-input v-model="fData.flag"/>
        </a-form-item>
      </a-col>
    </a-row>

    <a-form-item
      :labelCol="labelCol"
      :wrapperCol="wrapperCol"
      label="走马灯类型">
      <el-select v-model="form.type" placeholder="请选择">
        <el-option label='一般模式' value='' key="1"></el-option>
        <el-option label='卡片模式' value='card' key="2"></el-option>
      </el-select>
    </a-form-item>

    <a-form-item
      :labelCol="labelCol"
      :wrapperCol="wrapperCol"
      label="z显示方向">
      <el-select v-model="form.direction" placeholder="请选择">
        <el-option label='水平展示' value='horizontal' key="1"></el-option>
        <el-option label='垂直展示' value='vertical' key="2"></el-option>
      </el-select>
    </a-form-item>

    <a-form-item
      :labelCol="labelCol"
      :wrapperCol="wrapperCol"
      label="是否自动切换">
      <el-switch v-model="form.autoPlay"></el-switch>
    </a-form-item>

    <a-form-item
      :hidden="form.autoPlay==='true'"
      :labelCol="labelCol"
      :wrapperCol="wrapperCol"
      label="切换时间(秒)">
      <a-input v-model="form.intervalTime" placeholder="请输入自动切换时间"/>
    </a-form-item>

    <a-form-item
      :labelCol="labelCol"
      :wrapperCol="wrapperCol"
      label="切换箭头显示时机">
      <el-select v-model="form.arrow" placeholder="请选择">
        <el-option label='一直' value='always' key="1"></el-option>
        <el-option label='鼠标悬浮' value='hover' key="2"></el-option>
        <el-option label='从不' value='never' key="3"></el-option>
      </el-select>
    </a-form-item>

    <a-form-item
      :labelCol="labelCol"
      :wrapperCol="wrapperCol"
      label="指示器触发方式">
      <el-select v-model="form.triggerWay" placeholder="请选择">
        <el-option label='鼠标悬浮' value='hover' key="1"></el-option>
        <el-option label='鼠标点击' value='click' key="2"></el-option>
      </el-select>
    </a-form-item>

    <a-form-item
      :labelCol="labelCol"
      :wrapperCol="wrapperCol"
      label="指示器显示位置">
      <el-select v-model="form.position" placeholder="请选择">
        <el-option label='内部显示' value='' key="1"></el-option>
        <el-option label='外部显示' value='outside' key="2"></el-option>
        <el-option label='不显示' value='none' key="3"></el-option>
      </el-select>
    </a-form-item>

  </a-modal>
</template>
<script>
  export default {
    name: "eleImagesSimple",
    props: {
      uploadParam: {
        type: Object,
      }
    },
    data() {
      return {
        needDispose: false,
        title: '多图片组件编辑',
        urlList: [],
        isMultiple: false,
        model: {},
        headers: {},
        formLabelWidth: '120px',
        visible: false,
        conKey: '',
        componentFlag: '',
        labelCol: {
          xs: {span: 24},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },
        fileDatas: [],
        form: {
          type: '',
          direction: 'horizontal',
          autoPlay: true,
          intervalTime: 3,
          arrow: 'hover',
          triggerWay: 'hover',
          position: '',
        },
      }
    },
    watch: {
      urlList() {
        this.isMultiple = this.urlList.length > 1;
      }
    },
    computed: {
      uploadAction: function () {
        return this.uploadParam.fileUpload;
      }
    },
    created() {
      this.headers = {"X-Access-Token": this.uploadParam.accessToken}
    },
    methods: {
      beforeUpload: function (file) {
        let fileType = file.type;
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片');
          return false;
        }
      },
      handleChange(file) {
        if (file.status === 'ready') {
          return
        }
        if (file.status === 'success') {
          let Url = file.url;
          this.fileDatas.push({fileName: file.name, filePath: Url, flag: ""});
          this.urlList.push(Url);
        } else {
          this.$message.warning('图片上传失败！');
        }
      },
      pictureSure() {
        this.visible = false;
        this.form.autoPlay = this.form.autoPlay ? 1 : 0;
        this.$emit('setComponentData', JSON.stringify(
          Object.assign(this.form, {configFlag: this.needDispose ? 1 : 0},
            {params: JSON.stringify(this.fileDatas)})),
          this.conKey, this.componentFlag
        );
      },
      edit(conKey, componentFlag, componentDataStr) {
        this.visible = true;
        this.conKey = conKey;
        this.componentFlag = componentFlag;
        if (undefined != componentDataStr) {

          const componentData = JSON.parse(componentDataStr);
          this.needDispose = true;
          this.form = componentData;
          this.fileDatas = JSON.parse(componentData.params);
        }
      },
      close() {
        this.visible = false;
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/lib/editMoudle/eleImagesSimple.vue